import * as React from 'react';
import { Textarea, UIText3 } from '@cian/ui-kit';
import { debounce } from '@cian/newbuilding-utils';
import { useDispatch, useSelector } from 'react-redux';

import { getAnswerText, getIsOpen } from '../../selectors/newAnswer';
import { setAnswerText } from '../../actions/newAnswer';
import { ANSWER_MAX_LENGTH } from '../../constants/reviews';
import { getAuthorNameById, getIsAuthorAnonymousById } from '../../selectors/common';

export const AnswerTextContainer = () => {
  const dispatch = useDispatch();
  const openId = useSelector(getIsOpen);
  const author = useSelector(getAuthorNameById(openId));
  const isAnonymous = useSelector(getIsAuthorAnonymousById(openId));
  const initialValue = useSelector(getAnswerText) || isAnonymous ? '' : `${author}, `;
  const [value, setValue] = React.useState(initialValue);
  const [counter, setCounter] = React.useState(initialValue.length);

  const setAnswerTextDebounced = debounce(200, nextValue => dispatch(setAnswerText(nextValue)));

  const onChange = React.useCallback(
    (_event: React.ChangeEvent<HTMLTextAreaElement>, nextValue: string) => {
      const counter = nextValue.length;
      if (counter <= ANSWER_MAX_LENGTH) {
        setCounter(nextValue.length);
        setValue(nextValue);
        setAnswerTextDebounced(nextValue);
      }
    },
    [setValue, setAnswerTextDebounced],
  );

  return (
    <>
      <Textarea data-testid="AnswerTextarea" onChange={onChange} value={value} minRows={5} maxRows={8} width="100%" />
      <UIText3 color="gray40_100">{`${counter}/${ANSWER_MAX_LENGTH}`}</UIText3>
    </>
  );
};
